export default __webpack_public_path__ + "static/media/website.01a6e2f2.png";